import React, { ReactElement } from 'react';
import { AfterSubmitFunc, FormTemplate, TextArea, SubmitButton, CancelButton } from 'ui-builder';
import { TextAreaWithProjectMemberMention, useProjectId } from 'features/nekst-widgets';
import { CommentType, CommentRequestType } from './EditCommentForm';

interface ShadcnNoteFormProps<
  DataType extends CommentType,
  RequestType extends CommentRequestType,
> {
  title: string;
  submitFunc: (data: RequestType) => Promise<DataType>;
  afterSubmitFunc?: AfterSubmitFunc<DataType>;
  initialData?: Partial<RequestType>;
  additionalInputs?: ReactElement;
}

export default function ShadcnNoteForm<
  DataType extends CommentType = CommentType,
  RequestType extends CommentRequestType = CommentRequestType,
>(props: ShadcnNoteFormProps<DataType, RequestType>) {
  const projectId = useProjectId();

  const textInput = projectId
    ? (
      <TextAreaWithProjectMemberMention
        source="text"
        label="Enter note here"
        showRequiredIcon={false}
      />
    )
    : (
      <TextArea
        source="text"
        label="Enter note here"
        showRequiredIcon={false}
      />
    );

  return (
    <FormTemplate<RequestType, DataType>
      title={props.title}
      submitFormFunc={props.submitFunc}
      afterSubmitFunc={props.afterSubmitFunc}
      initialData={props.initialData as RequestType}
      validationSchema={{
        text: {
          type: 'string',
          constraints: {
            required: true,
          },
        },
      }}
      buttons={(
        <>
          <SubmitButton />
          <CancelButton />
        </>
      )}
    >
      {textInput}
      {props.additionalInputs}
    </FormTemplate>
  );
}
